import moment from 'moment'

// How many photos the strip shows before "+ more"
const SHOWN = 6

// Top of the recipe's activity: every photo the family posted in it, newest first.
// Tapping one opens it full screen. (Kept out of the recipe's own photos, which the
// printed cookbook uses.)
const FamilyPhotos = ({ photos = [], onOpen }) => {
  if (!photos.length) return null

  const people = new Set(photos.map(({ user }) => user.id)).size
  const shown = photos.slice(0, SHOWN)
  const more = photos.length - shown.length

  return (
    <section className="familyPhotos" aria-label="Photos from the family">
      <p className="familyPhotosNote">
        <span className="familyPhotosTitle">Made by the family</span> ·{' '}
        {photos.length === 1 ? '1 photo' : `${photos.length} photos`}
        {people > 1 ? ` from ${people} people` : ` from ${photos[0].user.fullname}`}
      </p>
      <div className="familyPhotosList">
        {shown.map((photo, index) => (
          <button
            type="button"
            key={photo.id}
            className="familyPhoto"
            onClick={() => onOpen(photo)}
            title={`${photo.user.fullname}, ${moment(photo.created_at).fromNow()}`}
          >
            <img src={photo.image} alt={`Photo from ${photo.user.fullname}`} loading="lazy" />
            {index === shown.length - 1 && more > 0 ? (
              <span className="familyPhotoMore">+{more}</span>
            ) : (
              <span className="familyPhotoName">{photo.user.fullname.split(' ')[0]}</span>
            )}
          </button>
        ))}
      </div>
    </section>
  )
}

export default FamilyPhotos
